import React from 'react';

const PersonIcon = () => {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.80734 10.4307C10.1421 10.4307 11.4222 9.90388 12.366 8.9662C13.3099 8.02852 13.8401 6.75675 13.8401 5.43066C13.8401 4.10458 13.3099 2.83281 12.366 1.89513C11.4222 0.957448 10.1421 0.430664 8.80734 0.430664C7.47257 0.430664 6.19246 0.957448 5.24864 1.89513C4.30481 2.83281 3.77457 4.10458 3.77457 5.43066C3.77457 6.75675 4.30481 8.02852 5.24864 8.9662C6.19246 9.90388 7.47257 10.4307 8.80734 10.4307ZM7.01049 12.3057C3.13761 12.3057 0 15.4229 0 19.2705C0 19.9111 0.522936 20.4307 1.16776 20.4307H16.4469C17.0917 20.4307 17.6147 19.9111 17.6147 19.2705C17.6147 15.4229 14.4771 12.3057 10.6042 12.3057H7.01049Z"
        fill="black"
      />
    </svg>
  );
};

export default PersonIcon;
